import { DOMAIN } from "@/root/constants"

export const getBreadCrumbList = (
  stockName: string,
  ticker: string,
  isAuthenticated: boolean,
  slug: string,
) => {
  if (!isAuthenticated) {
    return [
      { label: 'Home', link: DOMAIN },
      { label: 'US Stocks', link: `${DOMAIN}/us-stocks` },
      {
        label: `${stockName} Share Price ${ticker ? `(${ticker})` : ''}`,
        link: `${DOMAIN}/us-stocks/${slug}`,
      },
    ]
  }

  return [
    { label: 'Home', link: '/dashboard' },
    { label: 'US Stocks', link: '/investments/us-stocks/explore-all' },
    {
      label: `${stockName} Share Price ${ticker ? `(${ticker})` : ''}`,
      link: `${DOMAIN}/us-stocks/${slug}`,
    },
  ]
}
